@for (key of error?.keys; track key) { @if (key === 'emailIncorrect' &&
!!error?.type?.email) {
<li
  i18n="
    Label | The error displayed when email field validation
    fails@@formErrorEmailIncorrectLabel"
>
  Le format de l'adresse e-mail est incorrect
</li>
} @if (key === 'passwordRequired' && !!error?.type?.required) {
<li
  i18n="
    Label | The error displayed when password field validation
    fails@@formErrorPasswordIncorrectLabel"
>
  Le champ mot de passe est requis
</li>
} @if (key === 'passwordSecurity') {
<li
  i18n="
    Label | The error displayed when password field validation match fails
    because password security is not secured
    enough@@formErrorPasswordsSecurityFailsLabel"
>
  Critères de sécurité non respectés
</li>
} @if (key === 'passwordsDoNotMatch') {
<li
  i18n="
    Label | The error displayed when password field validation match fails
    because passwords mismatch@@formErrorPasswordsDoNotMatchLabel"
>
  Les mots de passe ne sont pas les mêmes
</li>
} @if (key === 'oldAndNewMatch') {
<li
  i18n="
    Label | The error displayed when password field validation match fails
    because old and new password are the same@@formErrorOldAndNewMatchLabel"
>
  Le nouveau mot de passe doit être différent de l'ancien
</li>
} @if (key === 'passwordLength' && !!error?.type?.minlength) {
<li
  i18n="
    Label | The error displayed when password field validation fails because of
    min length@@formErrorPasswordLengthLabel"
>
  8 caractères minimum
</li>
} @if (key === 'accessCodeIncorrect' && !!error?.type?.maxlength) {
<li
  i18n="
    Label | The error displayed when access code field validation fails because
    of max length@@formErrorAccessCodeLengthLabel"
>
  15 caractères maximum
</li>
} @if (key === 'roleIncorrect') {
<li
  i18n="
    Label | The error displayed when role field validation
    fails@@formErrorRoleIncorrectLabel"
>
  Le champ fonction est requis
</li>
} @if (key === 'phoneNumberIncorrect') {
<li
  i18n="
    Label | The error displayed when phone number field validation
    fails@@formErrorPhoneNumberIncorrectLabel"
>
  Le format du numéro de téléphone est incorrect
</li>
} @if (key === 'required' && !!error?.type?.required) {
<li
  i18n="
    Label | The error displayed when the field is required
    fails@@formErrorRequiredFieldLabel"
>
  Ce champs est réquis
</li>
} @if (key === 'noKey' && !!error?.type?.noKey) {
<li
  i18n="
    Label | The error displayed when no key is
    provided@@formErrorNoKeyFieldLabel"
>
  Une clef est requise
</li>
} @if (key === 'notUnique' && !!error?.type?.notUnique) {
<li
  i18n="
    Label | The error displayed when the value is not
    unique@@formErrorNotUniqueFieldLabel"
>
  La valeur "{{ error.type.notUnique }}" est déjà utilisée
</li>
} }
